export const EVENT_LABELS: { [key: string]: string } = {
  itemClicked: 'Item Clicked',
  buttonClicked: 'Button Clicked',
  contentConsumed: 'Content Consumed',
  contentOpened: 'Content Opened',
  click: 'Click',
  courseProgress: 'Course Progress',
  disciplineProgress: 'Discipline Progress',
  forumChannelOpened: 'Forum Channel Opened',
  forumCommentPosted: 'Forum Comment Posted',
  forumTopicCreated: 'Forum Topic Created',
  lessonPlayed: 'Lesson Played',
  lessonReacted: 'Lesson Reacted',
  linkNavigated: 'Link Navigated',
  menuClicked: 'Menu Clicked',
  modalViewed: 'Modal Viewed',
  noteInteracted: 'Annotation Interacted',
  notification: 'Notification',
  notificationInteracted: 'Notification Interacted',
  notificationViewed: 'Notification Viewed',
  notebookOpened: 'Notebook Opened',
  notebookInteracted: 'Notebook Interacted',
  microcertificateInteracted: 'Microcertificate Interacted',
  reportCardActivityClick: 'Report Card Activity Click',
  reportCardToggle: 'Report Card Toggle',
  reportCardView: 'Report Card View',
  smartBannerViewed: 'SmartBanner Viewed',
  smartBannerClicked: 'SmartBanner Clicked',
  studyPlanInteracted: 'Study Plan Interacted',
  termsOfUseAccepted: 'Terms Of Use Accepted',
  termsOfUseShowUp: 'Terms Of Use Show Up',
  acessibilityButtonClick: 'Accessibility Button Clicked',
};
